export default __webpack_public_path__ + "static/media/bbb-bw.8c4288f3.png";